import React from 'react'
import PropTypes from 'prop-types'
import { HashLink as Link } from 'react-router-hash-link'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Carousel from 'nuka-carousel'
import Squats from 'images/svg/squats.svg'
import Yoga from 'images/svg/yoga.svg'
import Running from 'images/svg/running.svg'
import WorkoutBox from './WorkoutBox'

const backgroundImage =
  'https://s3-us-west-1.amazonaws.com/healthfulinspired/app/home_workouts2.jpg'

const styles = (theme) => ({
  backgroundPhoto: {
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url('${backgroundImage}')`,
    backgroundSize: 'cover',
    backgroundAttachment: 'local',
  },
  headline: {
    color: '#fff',
    textTransform: 'uppercase',
    fontWeight: 700,
    textAlign: 'center',
    display: 'block',
    margin: 'auto',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1em',
      fontWeight: 500,
      padding: 0,
    },
  },
  subheading: {
    color: '#fff',
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: 10,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
      maxHeight: 23,
      padding: 6,
      marginBottom: 7,
      fontWeight: 300,
    },
  },
  workoutBoxContainer: {
    maxHeight: 280,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '10px 0',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  workoutBoxCarousel: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      width: '100%',
      height: 260,
    },
  },
  seeFullList: {
    color: '#fff',
    background: theme.palette.primary.main,
    textTransform: 'uppercase',
    display: 'block',
    margin: 'auto',
    position: 'relative',
    top: 20,
    width: 150,
    transition: 'background 0.7s, color 0.7s',
    '&:hover': {
      background: theme.palette.background.light,
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
      top: 0,
    },
  },
})

const WorkoutSlide = ({ classes, workoutsMentions }) => {
  const workoutsMentionsMap = workoutsMentions.reduce((acc, { node }) => {
    acc[node.frontmatter.title] = node.frontmatter.mentions
    return acc
  }, {})

  const workoutExercises = [
    {
      name: 'Squats',
      to: '/squats',
      Icon: Squats,
      description:
        'Increases muscles mass. Amplifies the muscle-building, fat-burning effect. Promotes quicker burning of calories.',
      color: 'primary.mainLighter',
      mentions: workoutsMentionsMap['Squats'],
    },
    {
      name: 'Running',
      to: '/running',
      Icon: Running,
      description:
        'Strengthens bones in legs and hips. Improves mood and promotes great sense of accomplishment. Burns calories quickly.',
      color: 'primary.main',
      mentions: workoutsMentionsMap['Running'],
    },
    {
      name: 'Power Yoga',
      to: '/power-yoga',
      Icon: Yoga,
      description:
        'Releases tension in the body and mind. Promotes intuitive eating. Provides physical, mental, and social benefits for weight loss.',
      color: 'primary.mainDarker',
      mentions: workoutsMentionsMap['Power Yoga'],
    },
  ]

  return (
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
        <div className={classes.backgroundPhoto} alt="" />
      </div>
      <div
        id="workouts"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ position: 'relative' }}>
          <Typography variant="display2" className={classes.headline}>
            Workout Exercises
          </Typography>
          <Typography
            variant="title"
            align="center"
            className={classes.subheading}
          >
            Curated For Weight Loss
          </Typography>

          <div className={classes.workoutBoxContainer}>
            {workoutExercises.map((props, i) => (
              <WorkoutBox key={`workout_box${i}`} {...props} />
            ))}
          </div>

          <div className={classes.workoutBoxCarousel}>
            <div style={{ width: '80vw', minHeight: '100%' }}>
              <Carousel
                cellSpacing={10}
                speed={700}
                autoplayInterval={3000}
                renderCenterLeftControls={null}
                renderBottomCenterControls={null}
                renderCenterRightControls={null}
                slidesToScroll={1}
                initialSlideHeight={260}
                swiping
                wrapAround
                autoplay
              >
                {workoutExercises.map((props, i) => (
                  <WorkoutBox key={`workouts_carousel_slide${i}`} {...props} />
                ))}
              </Carousel>
            </div>
          </div>
          <Link to="/weight-loss-workouts">
            <Button
              className={classes.seeFullList}
              size="small"
              variant="raised"
            >
              See full list
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

WorkoutSlide.propTypes = {
  classes: PropTypes.object.isRequired,
  workoutsMentions: PropTypes.array.isRequired,
}

export default withStyles(styles)(WorkoutSlide)



// WEBPACK FOOTER //
// ./src/components/Frontpage/WorkoutSlide.js